<script>
    let { disabled = false, manage = false, dataTest = '', onclick } = $props()
</script>

<button
    {onclick}
    {disabled}
    data-test={dataTest}
    class="h-7 px-4"
    class:btn-border={manage}
    class:btn-background={!manage}
>
    {manage ? 'Manage all outstanding invites' : 'Invite'}
</button>
